
/**
 * if function call repeats, will wait until timeout to run the latentFunction
 * immediateFunction is executed right away
 * @param latentFunction debounced rundown function
 * @param immediateFunction runs right away
 * @return delay to latentFunction running debounced
 */
 export function debounce(latentFunction, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { latentFunction.apply(this, args); }, timeout);
    };
  }
  
  export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';
  
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  
    const i = Math.floor(Math.log(bytes) / Math.log(k));
  
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }